import { createAsyncThunk } from '@reduxjs/toolkit';
import { postTransferFolderStructureToProject } from 'scenes/ProjectBank/services/postTransferFolderStructureToProject.service';

export const transferFolderStructureToProject = createAsyncThunk(
  'projectBank/transferFolderStructureToProject',
  async ({ sourceProjectId, targetProjectId }) => {
    const response = await postTransferFolderStructureToProject({
      sourceProjectId,
      targetProjectId,
    });

    return response;
  }
);
